import React from 'react';
import { Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/material';
import { Link } from 'react-router-dom';

export const TermsOfServiceLink: React.FC = () => {
  const theme = useTheme();

  return (
    <Grid item xs={12}>
      <Typography variant="body2">
        By starting your subscription, you agree to our{' '}
        <Link
          to="https://www.perfectvenue.com/terms-of-service"
          target="_blank"
          style={{
            textDecoration: 'none',
          }}
        >
          <Typography
            component="span"
            style={{
              color: theme.palette.secondary.main,
              cursor: 'pointer',
            }}
            variant="body2"
          >
            Terms of Service
          </Typography>
        </Link>
      </Typography>
    </Grid>
  );
};

